import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAdminModule } from '../sharedadmin/sharedadmin.module';
import { LoginComponent } from 'src/app/Admin/login/login.component';
import { AdminsignupComponent } from 'src/app/Admin/adminsignup/adminsignup.component';
import { AdminForgotPasswordComponent } from 'src/app/Admin/admin-forgot-password/admin-forgot-password.component';
import { AdminDashboardComponent } from 'src/app/Admin/admin-dashboard/admin-dashboard.component';
import { DataTablesModule } from "angular-datatables";
import { UsersComponent } from 'src/app/Admin/users/users.component';
import { BrowserModule } from '@angular/platform-browser';
import { RulesComponent } from 'src/app/Admin/rules/rules.component';
import { BasicActionsComponent } from 'src/app/Admin/DatatableEvents/basic-actions.component';
import { NewRuleComponent } from 'src/app/Admin/modals/new-rule/new-rule.component';
import { ConfirmComponent } from 'src/app/Admin/modals/confirm/confrim.component';
import { NewSkillComponent } from 'src/app/Admin/modals/new-skill/new-skill.component';
import { SkillsComponent } from 'src/app/Admin/skills/skills.component';
import { OptionsComponent } from 'src/app/Admin/options/options.component';
import { NewOptionComponent } from 'src/app/Admin/modals/new-option/new-option.component';
import { NewChoiceComponent } from 'src/app/Admin/modals/new-choice/new-choice.component';
import { ChoicesComponent } from 'src/app/Admin/choice/choices.component';
import { LevelsComponent } from 'src/app/Admin/levels/levels.component';
import { NewLevelComponent } from 'src/app/Admin/modals/new-level/new-level.component';
import { CategoriesComponent } from 'src/app/Admin/categories/categories.component';
import { NewCategoryComponent } from 'src/app/Admin/modals/new-category/new-category.component';
import { VideosComponent } from 'src/app/Admin/videos/videos.component';
import { NewVideoComponent } from 'src/app/Admin/modals/new-video/new-video.component';
import { UserActionsComponent } from 'src/app/Admin/DatatableEvents/user-actions.component';
import { EditUserComponent } from 'src/app/Admin/modals/edit-user/edit-user.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SubscriptionsComponent } from 'src/app/Admin/subscriptions/subscriptions.component';
import { CancelSubscriptionComponent } from 'src/app/Admin/modals/cancel-subscription/cancel-subscription.component';
import { SubscriptionActionsComponent } from 'src/app/Admin/DatatableEvents/subscription-actions.component';
import { NewSubscriptionComponent } from 'src/app/Admin/modals/new-subscription/new-subscription.component';
import { AddUserComponent } from 'src/app/Admin/modals/add-user/add-user.component';
import { InstructorsComponent } from 'src/app/Admin/instructors/instructors.component';
import { NewInstructorComponent } from 'src/app/Admin/modals/new-instructor/new-instructor.component';
import { SignatureseriesComponent } from 'src/app/Admin/signatureseries/signatureseries.component';
import { NewSignatureseriesComponent } from 'src/app/Admin/modals/new-signatureseries/new-signatureseries.component';
import { TagInputModule } from 'ngx-chips';
import { SeriesvideosComponent } from 'src/app/Admin/seriesvideos/seriesvideos.component';
import { NewSeriesvideoComponent } from 'src/app/Admin/modals/new-seriesvideo/new-seriesvideo.component';
import { MessageComponent } from 'src/app/Admin/message/message.component';
import { EditorModule,TINYMCE_SCRIPT_SRC  } from '@tinymce/tinymce-angular';
import { NumbersOnlyDirective } from 'src/app/directives/numbers-only.directive';


@NgModule({
  declarations: [
    AdminComponent,
    LoginComponent,
    AdminsignupComponent,
    AdminForgotPasswordComponent,
    AdminDashboardComponent,
    UsersComponent,
    RulesComponent,
    ChoicesComponent,
    CategoriesComponent,
    NewCategoryComponent,
    LevelsComponent,
    NewLevelComponent,
    SkillsComponent,
    InstructorsComponent,
    NewInstructorComponent,
    SignatureseriesComponent,
    NewSignatureseriesComponent,
    OptionsComponent,
    BasicActionsComponent,
    UserActionsComponent,
    NewRuleComponent,
    NewChoiceComponent,
    NewSkillComponent,
    NewOptionComponent,
    ConfirmComponent,
    CancelSubscriptionComponent,
    SubscriptionActionsComponent,
    VideosComponent,
    NewVideoComponent,
    EditUserComponent,
    SubscriptionsComponent,
    NewSubscriptionComponent,
    AddUserComponent,
    SeriesvideosComponent,
    NewSeriesvideoComponent,
    MessageComponent,
    NumbersOnlyDirective
  ],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
  imports: [
    BrowserModule,
    CommonModule, 
    RouterModule,
    ReactiveFormsModule,
    SharedAdminModule,
    FormsModule,
    DataTablesModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TagInputModule,
    EditorModule
  ]
})

export class AdminModule { }
